export const getAITypesList = (t) => [
  { value: 'all', label: t('All') },
  { value: 'regular', label: t('Regular') },
  { value: 'waitesWireless', label: t('Hardware') },
];
